import { render, staticRenderFns } from "./trackingPedido.vue?vue&type=template&id=45c5fd70&"
import script from "./trackingPedido.vue?vue&type=script&lang=js&"
export * from "./trackingPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports